module.exports.commands = [
  {
    combo: 'cmd+b',
    key: 'bold'
  },
  {
    combo: 'cmd+i',
    key: 'italic'
  },
  {
    combo: 'cmd+e',
    key: 'quote'
  },
  {
    combo: 'cmd+j',
    key: 'code'
  },
  {
    combo: 'cmd+o',
    key: 'ol'
  },
  {
    combo: 'cmd+u',
    key: 'ul'
  },
  {
    combo: 'cmd+d',
    key: 'heading'
  },
  {
    combo: 'cmd+k',
    key: 'link'
  },
  {
    combo: 'cmd+g',
    key: 'media'
  },
  {
    combo: 'cmd+h',
    key: 'hr'
  }
];

module.exports.settings = {
  lineLength: 80
};
